import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/Rihal_logo-fullcolor-rgb.svg';
import { AiOutlineLogin } from "react-icons/ai";
import { RiLogoutCircleLine } from "react-icons/ri";


const LoginSignUpPage = () => {




  return (
    <div className="relative min-h-screen flex justify-center items-center bg-gradient-to-t from-green-400 to-green-100 ">
      {/* Particle Engine Component for Background */}
    
      <img src={logo} alt='logo' className='bg-transparent blur-sm w-full h-full absolute p-40'/>
      <div className="backdrop-blur-md absolute rounded-3xl shadow-lg w-full max-w-4xl h-max z-20 p-48 ">
        <h2 className="text-4xl font-semibold text-center mb-6">مرحباً بك في <span className='text-green-400 font-bold'>رحال </span></h2>
        <h2 className="text-2xl font-semibold text-center mb-20">سجل من فضلك للتقدم الى موقعنا</h2>
        <div className="flex flex-row justify-center items-center">
          <Link
            to="/LoginChoicePage"
            className="bg-[#189475] text-white text-center text-2xl px-8 py-6 mx-2 rounded-full flex justify-center items-center hover:bg-green-300 transition-colors"
          >
            <AiOutlineLogin className='mx-2 text-nowrap'/>
            تسجيل الدخول
          </Link>
          <Link
            to="/SignUpChoicePage"
            className="bg-[#189475] text-white text-center text-2xl px-8 py-6 mx-2 rounded-full flex justify-center items-center hover:bg-green-300 transition-colors"
          >
            <RiLogoutCircleLine className='mx-2 text-nowrap'/>
            انشاء حساب
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginSignUpPage;
